/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class SmartModuleService extends Service {
    constructor(axios) {
        super(axios);
        /** @FIXME API에 제거 요청. 수정해주면 이후 아래 로직 제거 필요 */
        this.setContentTypeHeaderInterceptor();
    }
    /** 도면 파일 가져오기 */
    getDrawingFileBySiteId = async (siteId) => {
        return await this.get(apiWrapper.managerApi(`/devices/profiles/ac/drawing/${siteId}/sites`));
    };
    /** 도면 파일 추가 및 업데이트 */
    saveDrawingFileBySiteId = async (siteId, data) => {
        const response = await this.post(apiWrapper.managerApi(`/devices/profiles/ac/drawing/${siteId}/sites`), data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    };
    /** 모듈 정보 조회 */
    getModulesInfoBySiteId = async (siteId) => {
        const { data } = await this.get(apiWrapper.managerApi(`/devices/telemetries/ac/${siteId}/mi-profiles`));
        return data.result;
    };
    getEnergyMonitoringInfoBySiteId = async (siteId, interval, params) => {
        const { data } = await this.get(apiWrapper.managerApi(`/devices/telemetries/ac/${siteId}/energies/${interval}`), params);
        return data.result;
    };
    /** 15분 단위 PV 전력 정보 조회 */
    get15MinPvPowerInfoACBySiteId = async (siteId, params) => {
        const { data } = await this.get(apiWrapper.managerApi(`/devices/telemetries/ac/${siteId}/powers`), params);
        return data.result;
    };
    /** MI 이력 정보 조회 */
    getMicroInverterActivities = async (siteId, deviceId, MicroInverterActivityParam) => {
        const { data } = await this.get(apiWrapper.managerApi(`/sites/${siteId}/devices/${deviceId}/micro-inverters/activities`), MicroInverterActivityParam);
        return data.body;
    };
}
export { SmartModuleService };
